import { connect } from 'react-redux';
import { getTheme, getShowMatureContent, getIsLoggedIn, getCurrentUser, getPointsCount, getCsrfToken, getCurrentUserHasCore, getFeedbackUrl, getVerificationEmailAddress, getCanEnableToggleMatureContent, getThemeSkin, getCurrentUserHasWixPortfolio, getHasJoinedWithEclipse, } from '../publicSession/selectors';
import { toggleMature, toggleTheme, setTheme, setThemeSkin, switchVersion, } from '../publicSession/actions';
import { actions as modalActions } from '../Modals';
import { ModalType } from '../Modals/redux/types';
import { pushModal } from '../Modals/redux/basicActions';
import { userLogoutButtonClicked } from './redux/actions';
var mapStateToProps = function (state) { return ({
    csrfToken: getCsrfToken(state),
    currentUser: getCurrentUser(state),
    isLoggedIn: getIsLoggedIn(state),
    verificationEmail: getVerificationEmailAddress(state),
    theme: getTheme(state),
    themeSkin: getThemeSkin(state),
    matureContent: getShowMatureContent(state),
    pointsCount: getPointsCount(state),
    hasCoreMembership: getCurrentUserHasCore(state),
    hasWixPortfolio: getCurrentUserHasWixPortfolio(state),
    hasJoinedWithEclipse: getHasJoinedWithEclipse(state),
    feedbackUrl: getFeedbackUrl(state),
    canEnableMatureContent: getCanEnableToggleMatureContent(state),
}); };
var mapDispatchToProps = {
    toggleTheme: toggleTheme,
    toggleMature: toggleMature,
    switchVersion: switchVersion,
    pushMyGroupsModal: modalActions.pushMyGroupsModal,
    setTheme: setTheme,
    setThemeSkin: setThemeSkin,
    pushWixPortfolioModal: function () {
        return pushModal(ModalType.WIX_PORTFOLIO_CREATE, { wrapInPopup: false });
    },
    onUserLogoutButtonClicked: userLogoutButtonClicked,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=UserMenu.container.js.map